<table
	class="table"
	*ngIf="buildinglogs">
	<tbody>
		<tr>
			<th class="not-editable large-col">{{'labels.project' | translate}}</th>
			<th class="not-editable large-col">{{'labels.activity' | translate}}</th>
			<th class="not-editable large-col">{{'labels.days-use' | translate}}</th>
			<th class="not-editable large-col">{{'labels.perc-use' | translate}}</th>
			<th class="not-editable large-col">{{'labels.total-cost' | translate}}</th>
		</tr>
		<tr *ngFor="let item of buildinglogs; let i = index">
			<th class="not-editable large-col">{{item.project.name}}</th>
			<th class="not-editable large-col">{{item.activity.name}}</th>
			<th class="large-col">
				<input
					type="number"
					class="form-control"
					[(ngModel)]="item.days"
					min="0"
					[max]="item.maxdays"
					[ngClass]="{'is-invalid': item.days < 0 || item.days > item.maxdays}">
				<small
					*ngIf="item.days < 0 || item.days > item.maxdays"
					class="pt-3 text-danger">
					<br>
					L'attività ha una durata massima di {{item.maxdays}} giorni
				</small>
			</th>
			<th class="large-col">
				<input
					type="number"
					class="form-control"
					[(ngModel)]="item.useprecentage"
					min="0"
					max="100"
					[ngClass]="{'is-invalid': item.useprecentage < 0 || item.useprecentage > 100}">
				<small
					*ngIf="item.useprecentage < 0 || item.useprecentage > 100"
					class="pt-3 text-danger">
					<br>
					Inserire valore tra 0 e 100
				</small>
			</th>
			<th class="large-col">
				{{item.building.daylyvalue * item.days * (item.useprecentage / 100) | currency: '€'}}
			</th>
		</tr>
	</tbody>
</table>
<div class="modal-footer">
	<button
		class="btn btn-primary"
		(click)="save()">
		{{'labels.save' | translate}}
	</button>
</div>
